import { createAction } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const fetchBusinessAddresses = createAction("".concat(stateName, "/fetchBusinessAddresses"));